/* import __COLOCATED_TEMPLATE__ from './language-selector.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import {
  FIN_SUPPORTED_LANGUAGES,
  type Language,
} from '../../../../lib/ai-content-library/constants';
import type LocalizedEmailContentModel from '../../../../models/emails/localized-email-content';

interface LanguageOption {
  text: string;
  value: string;
}

interface Signature {
  Element: HTMLDivElement;
  Args: {
    localizedEmailContent: LocalizedEmailContentModel;
  };
}

export default class LanguageSelector extends Component<Signature> {
  get languageOptions(): LanguageOption[] {
    return FIN_SUPPORTED_LANGUAGES.map((language: Language) => {
      return {
        text: language.name,
        value: language.locale,
      };
    });
  }

  get activeLocale(): string {
    return this.args.localizedEmailContent.locale;
  }

  @action
  onLocaleClick(locale: string): void {
    this.args.localizedEmailContent.locale = locale;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Email::Composer::Sidebar::LanguageSelector': typeof LanguageSelector;
    'email/composer/sidebar/language-selector': typeof LanguageSelector;
  }
}
